<template>
  <div style="display:inline-block;">
    <a
      v-show="show"
      class="js-code-bbtn btn"
      data-url="ddd"
      href="javascript:;"
      :disabled="isDisabled || isSending"
      @click="handleGetCode"
    >
      {{ $t('message["460"]') }}
    </a>
    <em
      v-show="!show"
      class="btn counter send-time"
    >{{ counter }}s</em>
  </div>
</template>

<script>
// mport { fetchApi } from '@/common'
import { validCode, geetestInit } from '@/services'
export default {
  props: {
    type: {
      type: String,
      default: '1'
    },
    mobile: {
      type: String,
      default: ''
    },
    email: {
      type: String,
      default: ''
    },
    newmobile: {
      type: String,
      default: ''
    },
    newemail: {
      type: String,
      default: ''
    },
    username: {
      type: String,
      default: ''
    },
    // 按钮是否禁止
    isDisabled: {
      type: Boolean,
      default: true
    },
    imgcaptcha: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      timer: null,
      counter: 60,
      show: true,
      isSending: false,
      captchaObj: null,
      captchaReady: false
    }
  },
  computed: {
    needGeetest () {
      return [1, 3, 7, 9, 10, 11, 12, 13, 14].includes(parseInt(this.type))
    },
    fileds () {
      const type = parseInt(this.type)
      if (type === 1 || type === 3 || type === 7) {
        return {
          type,
          mobile: this.mobile
        }
      } else if (type === 2 || type === 4 || type === 8) {
        return {
          type,
          email: this.email
        }
      } else if (type === 5) {
        return {
          type,
          newmobile: this.newmobile,
          mobile: this.mobile
        }
      } else if (type === 6) {
        return {
          type,
          newemail: this.newemail
        }
      } else if (type === 9) {
        return {
          type,
          mobile: this.mobile
        }
      } else if (type === 10) {
        return {
          type,
          mobile: this.mobile
        }
      } else if (type === 11) {
        return {
          type,
          mobile: this.mobile
        }
      } else if (type === 12) {
        return {
          type,
          mobile: this.mobile
        }
      } else if (type === 13) {
        return {
          type,
          mobile: this.mobile
        }
      } else if (type === 14) {
        return {
          type,
          mobile: this.mobile
        }
      } else {
        return {
          type,
          mobile: this.mobile
        }
      }
    }
  },
  methods: {
    handleGetCode () {
      if (this.isDisabled || this.isSending) return
      if (this.needGeetest) {
        this.initGeetest()
      } else {
        this.sendCode()
      }
    },
    async initGeetest () {
      this.isSending = true
      if (!/^1[3-9]\d{9}$/.test(this.mobile)) {
        this.isSending = false
        this.$selefToast({ type: 'error', text: '请输入正确的手机号' })
        return
      }
      if (!window.initGeetest) {
        this.isSending = false
        this.$selefToast({ type: 'error', text: '验证码加载失败，请刷新页面重试' })
        return
      }
      if (this.captchaObj) {
        this.captchaObj.reset()
        this.showGeetestCaptcha()
        return
      }
      await geetestInit()
        .params({
          mobile: this.mobile
        })
        .onSuccess((payload, res) => {
          const geetestConfig = payload || res
          if (!geetestConfig || !geetestConfig.gt) {
            this.isSending = false
            this.$selefToast({ type: 'error', text: '验证码初始化参数错误' })
            return
          }
          window.initGeetest({
            gt: geetestConfig.gt,
            challenge: geetestConfig.challenge,
            offline: !geetestConfig.success, // 极验服务器是否宕机
            product: 'bind',
            width: '100%',
            https: true
          }, (captchaObj) => {
            this.captchaObj = captchaObj
            this.captchaReady = false
            captchaObj.onReady(() => {
              this.captchaReady = true
              this.isSending = false
              this.showGeetestCaptcha()
            })
            captchaObj.onSuccess(async () => {
              const result = captchaObj.getValidate()
              await this.sendSms(result, geetestConfig.geetest_key)
              captchaObj.reset()
            })
            captchaObj.onError(() => {
              this.isSending = false
              this.$selefToast({ type: 'error', text: '验证失败，请重试' })
            })
            captchaObj.onClose(() => {
              this.isSending = false
            })
          })
        })
        .onFail(() => {
          this.isSending = false
        })
        .config({ tip: false })
        .fetch()
    },
    async sendCode () {
      await this.fetchCode(this.fileds)
    },
    showGeetestCaptcha () {
      if (!this.captchaObj) return
      if (!this.captchaReady) return
      if (this.captchaObj.verify) {
        this.captchaObj.verify()
      } else if (this.captchaObj.showCaptcha) {
        this.captchaObj.showCaptcha()
      }
    },
    async sendSms (geetestData, geetestKey) {
      if (!/^1[3-9]\d{9}$/.test(this.mobile)) {
        this.$selefToast({ type: 'error', text: '请输入正确的手机号' })
        return
      }
      await this.fetchCode({
        ...this.fileds,
        geetest_challenge: geetestData.geetest_challenge,
        geetest_validate: geetestData.geetest_validate,
        geetest_seccode: geetestData.geetest_seccode,
        geetest_key: geetestKey
      })
    },
    async fetchCode (params) {
      this.isSending = true
      await validCode()
        .params(params)
        .onSuccess((raw, res) => {
          if (!res.error) {
            this.showCount()
            this.$emit('getRes', res.payload)
          }
        })
        .onNetSuccess((res) => {
          // console.log(res.data.message)
          // const toast = this.$createToast({
          //   time: 2000,
          //   txt: res.data.message,
          //   type: 'txt'
          // })
          // toast.show()
          const error = res.data.error
          if (!error) {
            this.$selefToast({ text: res.data.message })
          } else {
            this.$selefToast({ type: 'error', text: res.data.message })
          }
        })
        .onNetComplete(() => {
          this.isSending = false
        })
        .config({ tip: false })
        .fetch()
    },
    showCount () {
      const that = this
      that.show = false
      const defaultCount = that.counter
      const interval = setInterval((params) => {
        if (that.counter <= 1) {
          that.show = true
          that.counter = defaultCount
          clearInterval(interval)
        } else {
          that.counter--
        }
      }, 1000)
    }
  }
}
</script>
<style lang="scss" scoped>
  .send-time {
    color: #b3b3b3;
  }
</style>
